module.exports = __webpack_public_path__ + "img/005.f4de84da.png";